<section
  [ngClass]="{disabled: disabled}"
>
  <input
    id="wa-checkbox"
    type="checkbox"
    [checked]="whatsappEnabled"
    (change)="toggle()"
    [disabled]="disabled"
  />
  <label
    [class.on]="whatsappEnabled"
    class="background-hover border-border"
    for="wa-checkbox"
  >Toggle</label>
</section>
